module.exports = __webpack_public_path__ + "static/media/horrormax-banner-teenage-ghost-punk.5e9f2e38.jpg";